import React, { useEffect, useRef } from "react";
import styles from "./HtmlPopup.module.scss";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";

interface accordionType {
  showPopup: boolean;
  setShowPopup: (value: boolean | ((prev: boolean) => boolean)) => void;
  title: string;
  htmlContent: any;
  isAccordion?: boolean;
}

const HtmlPopup = ({
  showPopup,
  setShowPopup,
  title = "",
  htmlContent,
  isAccordion = false,
}: accordionType) => {

  const { isMobileDevice } = useSelector((state: any) => state.data);

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const container = containerRef.current;
      if (!container) return;
      if (!isAccordion){
        // clearInterval(interval);
        const headers = container.querySelectorAll<HTMLButtonElement>(
          ".toggleItemHeader"
        );
        const bodies = container.querySelectorAll<HTMLElement>(
          ".togggleItemBody"
        );
        if (!headers.length || !bodies.length) return;
        headers.forEach((header, i) => {
          const body = bodies[i];
          header.addEventListener("click", () => {
            const isActive = header.classList.contains("active");
            headers.forEach((h, j) => {
              h.classList.remove("active");
              bodies[j]?.classList.remove("open");
            });
            if (!isActive) {
              header.classList.add("active");
              body?.classList.add("open");
            }
          });
        });
        const feeHead = container.querySelectorAll<HTMLButtonElement>(
          ".feeHead"
        );
        const feeBody = container.querySelectorAll<HTMLElement>(
          ".feeBody"
        );
        if (!feeHead.length || !feeBody.length) return;
        feeHead.forEach((headerFee, i) => {
          const bodyfee = feeBody[i];
          headerFee.addEventListener("click", () => {
            const isActive = headerFee.classList.contains("active-fee");
            feeHead.forEach((h, j) => {
              h.classList.remove("active-fee");
              feeBody[j]?.classList.remove("open-fee");
            });
            if (!isActive) {
              headerFee.classList.add("active-fee");
              bodyfee?.classList.add("open-fee");
            }
          });
        });
        clearInterval(interval);
      } else{
        const headers = container.querySelectorAll<HTMLButtonElement>(
          ".popup-accordion-header"
        );
        const bodies = container.querySelectorAll<HTMLElement>(
          ".popup-accordion-body"
        );
        if (!headers.length || !bodies.length) return;
        headers.forEach((header, i) => {
          const body = bodies[i];
          if (i === 0) {
            header.classList.add("active");
            body?.classList.add("open");
          }
          header.addEventListener("click", () => {
            const isActive = header.classList.contains("active");
            headers.forEach((h, j) => {
              h.classList.remove("active");
              bodies[j]?.classList.remove("open");
            });
            if (!isActive) {
              header.classList.add("active");
              body?.classList.add("open");
            }
          });
        });
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, [htmlContent]);

  return (
    <div className="main_modal">
      <Modal
        show={showPopup}
        onHide={() => setShowPopup(false)}
        backdrop="static"
        keyboard={false}
        dialogClassName={styles.modalCustom}
        contentClassName={styles.modalContent}
        backdropClassName={styles.modalBackdrop}
      >
        {!isAccordion &&<Modal.Header
          className={
            // isMobileDevice ? "justify-content-center" : 
            `justify-content-end px-0 ${styles?.['pb-40']}`
          }
        >
          <Button
              className={styles.btnclose}
              onClick={() => setShowPopup(false)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.9994 15L9 9M9.00064 15L15 9"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                  stroke="white"
                />
              </svg>
            </Button>
        </Modal.Header>}
        <Modal.Body className={styles.custom_modal_body}>
          {isAccordion && <div className={styles.bodywp}>
            <h4>{title}</h4>
            {isAccordion &&<Button
              className={styles.btnclose}
              onClick={() => setShowPopup(false)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.9994 15L9 9M9.00064 15L15 9"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                  stroke="white"
                />
              </svg>
            </Button>}
          </div>}
          <div className={`${!isAccordion && styles.wrapper1} ${styles.wrapper}`}>
            <div
              ref={containerRef}
              className={styles.cmsAccordion}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HtmlPopup;
